import React from 'react';
import clsx from 'clsx';
import MuiListSubheader from '@material-ui/core/ListSubheader';
import { LIST_SUBHEADER } from 'ctsutheme/core';

const ListSubHeader = ({
  className, flex, ...props
}) => (
  <MuiListSubheader
    className={clsx(LIST_SUBHEADER.root, className, flex && LIST_SUBHEADER.flex)}
    {...props}
  />
);

export default ListSubHeader;
